import { useMemo } from 'react';

import { cn } from '~/lib/cn';

import { useGlobalSearchContext } from '../../hooks/useGlobalSearchContext';
import { splitToHighlightedPart } from '../../lib/utils';

export interface HighlightedTextProps {
  text: string;
  className?: string;
}

export function HighlightedText({ text, className }: HighlightedTextProps) {
  const { searchQuery } = useGlobalSearchContext();
  const highlightedDescription = useMemo(
    () => splitToHighlightedPart(text, searchQuery),
    [text, searchQuery],
  );

  return (
    <span className={cn('text-default', className)}>
      <span className="text-subtle">{highlightedDescription.startPart}</span>
      {highlightedDescription.matchingPart}
      <span className="text-subtle">{highlightedDescription.endPart}</span>
    </span>
  );
}

HighlightedText.displayName = 'HighlightedText';
